import {
  FeaturedTestimonyResult,
  UpdateFeaturedTestimonyPictureResult,
} from '../../api-results/abstract-testimony/featured-testimony.api-result';
import { FeaturedTestimonyPublicationStatus } from '../../enums/publication-status.enums';
import {
  FeaturedTestimonyFormValue,
  UpdateFeaturedTestimonyPayload,
} from '../../payloads/testimony/featured-testimony.payload';
import { AbstractTestimony } from './abstract-testimony.entity';
import { Writer } from '../writer.entity';

export class FeaturedTestimony extends AbstractTestimony {
  firstName: string;
  rank: number;
  quote: string;
  picture: string;
  publicationStatus: FeaturedTestimonyPublicationStatus;

  author: Writer;

  constructor(result: FeaturedTestimonyResult) {
    super(result);

    this.firstName = result.firstName;
    this.rank = result.rank;
    this.quote = result.quote;
    this.picture = result.picture;
    this.publicationStatus = result.publicationStatus;

    if (result.author) {
      this.author = new Writer(result.author);
    }
  }

  toFormValue(): FeaturedTestimonyFormValue {
    return {
      firstName: this.firstName,
      ecnRank: this.ecnRank,
      rank: this.rank,
      content: this.content,
      quote: this.quote,
      picture: {
        file: null,
        path: this.picture,
      },
    };
  }

  static updatedEntityToResult(
    payload: UpdateFeaturedTestimonyPayload,
    updatePictureResult: UpdateFeaturedTestimonyPictureResult
  ): Partial<FeaturedTestimonyResult> {
    return {
      quote: payload.quote,
      rank: payload.rank,
      picture: updatePictureResult.picture,
      firstName: payload.firstName,
    };
  }
}
